import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import LayoutPage from "../Layout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import moment from "moment";
import { formatEastern } from "../../utils/easternDate";

function Winners() {
  const location = useLocation();
  const params = useParams();
  const [row, setRow] = useState([]);
  const [categoryData, setCategoryData] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const navigate = useNavigate();

  const handleCloseButton = () => {
    navigate(-1);
  };

  const handlePageChange = (number) => {
    setPageNumber(number);
  };

  const handlePerRowsChange = (number) => {
    setPageSize(number);
  };
  const getCategoryData = useCallback(async () => {
    try {
      setLoading(true);
      axios
        .get(
          `website/get-contest-winner?pageNumber=${pageNumber}&pageSize=${pageSize}&sortOrder=asc&sportsCategory=${params.id}`,
        )
        .then((res) => res.data.data)
        .then((data) => {
          // console.log("Data",data);
          setCategoryData(data.result);
          setRow(data);
          setLoading(false);
        });
    } catch (error) {
      console.log("error", error);
    }
  }, [pageSize, pageNumber]);

  useEffect(() => {
    getCategoryData();
    if (location.state) {
      let msg = location.state.message;
      window.history.replaceState({}, document.title);
      navigate(location.pathname, { replace: true });
      toast(msg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "success",
      });
    }
  }, [location, getCategoryData]);

  //Table collumns
  const columns = [
    {
      name: "Date",
      minWidth: "150px",
      grow: 1,

      selector: (row) => formatEastern(row.date, { dateOnly: true }),
      // new Intl.DateTimeFormat("en-US", {
      //   timeZone: "America/New_York", // GMT-0500
      //   month: "short",
      //   day: "2-digit",
      //   year: "numeric",
      //   hour: "2-digit",
      //   minute: "2-digit",
      //   hour12: false,
      // })
      //   .format(new Date(row.date))
      //   .replace(",", ""),
      // moment(row.date).format("MMM-DD-YYYY HH:MM"),
    },
    {
      name: "Rank",
      selector: (row) => row.rank,
    },
    {
      name: "User Name",
      selector: (row) => row.userName,
    },

    {
      name: "Contest Pts",
      selector: (row) => row.contest_pts.toFixed(3),
    },
    {
      name: "Cumul Pts",
      selector: (row) => row.cumul_sport_pts.toFixed(3),
    },
    {
      name: "All Pts",
      selector: (row) => row.all_sport_pts.toFixed(3),
    },
  ];

  const customStyle = {
    header: {
      style: {
        border: "1px solid gray",
      },
    },
    headRow: {
      style: {
        fontSize: "1.2rem",
        border: "1px solid gray",
        backgroundColor: "#8180a6",
      },
    },
    rows: {
      style: {
        fontSize: "1.2rem",
        // fontWeight:
        border: "1px solid gray",
      },
    },
    pagination: {
      style: {
        fontSize: "1.2rem",
        border: "1px solid gray",
        backgroundColor: "#8180a6",
      },
    },
  };

  return (
    <>
      <Helmet>
        <title>Category Management</title>
      </Helmet>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                  }}
                  className=" shadow-primary border-radius-lg pt-0 pb-3"
                >
                  <h6 className="text-white text-capitalize ps-3 custom-card-heading">
                    <div className="d-flex justify-content-between align-item-center px-4">
                      {row.sportName} Winners{" "}
                      <i
                        className="fa fa-close fonts"
                        onClick={handleCloseButton}
                        style={{ cursor: "pointer" }}
                      ></i>
                    </div>
                  </h6>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <div className="input-group input-group-dynamic">
                    &nbsp; &nbsp;
                  </div>
                  {/* <h1>Sports Categories</h1> */}
                  <div className="table-responsive p-0">
                    <DataTable
                      columns={columns}
                      data={categoryData}
                      progressPending={loading}
                      paginationServer
                      paginationTotalRows={row.total}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onChangePage={handlePageChange}
                      sortServer
                      pagination
                      responsive
                      persistTableHead
                      // onSort={handleSort}
                      customStyles={customStyle}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default Winners;
